import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import useCustomTranslation from "../../hooks/useCustomTranslation";
import { fetchWorkoutHistoryThunk } from "../../redux/Slices/workoutHistorySlice";
import Loader from "../../components/Common/Loader";
import WorkoutListItemTable from "./WorkoutListItemTable";
import { resetWorkoutHistory } from "../../redux/Slices/workoutHistorySlice";
function WorkoutHistory({ selectedClientId, selectedCoachId }) {
  const dispatch = useDispatch();
  const { workoutHistoryList, isloading } = useSelector(
    (state) => state.getWorkoutHistory
  );
  const [group, setGroup] = useState([]);
  const { trans } = useCustomTranslation();

  useEffect(() => {
    if (!selectedClientId || !selectedCoachId) return;
    dispatch(resetWorkoutHistory());
    dispatch(
      fetchWorkoutHistoryThunk({
        clientId: selectedClientId,
        coachId: selectedCoachId,
      })
    );
  }, [dispatch, selectedClientId, selectedCoachId]);

  useEffect(() => {
    if (!workoutHistoryList?.length) {
      setGroup([]);
      return;
    }

    // const uniqueWorkouts = Array.from(
    //   new Map(
    //     workoutHistoryList.map((w) => [w.id || w.workoutDate, w])
    //   ).values()
    // );

    const sortedWorkouts = [...workoutHistoryList].sort(
      (a, b) => new Date(a.workoutDate) - new Date(b.workoutDate)
    );

    const groupedWorkouts = [];
    let currentGroup = [sortedWorkouts[0]];

    for (let i = 1; i < sortedWorkouts.length; i++) {
      const currentDate = new Date(sortedWorkouts[i].workoutDate);
      const lastDate = new Date(
        currentGroup[currentGroup.length - 1].workoutDate
      );

      const diffDays = (currentDate - lastDate) / (1000 * 3600 * 24);

      if (diffDays <= 5) {
        currentGroup.push(sortedWorkouts[i]);
      } else {
        groupedWorkouts.push(currentGroup);
        currentGroup = [sortedWorkouts[i]];
      }
    }

    if (currentGroup.length > 0) {
      groupedWorkouts.push(currentGroup);
    }

    setGroup(groupedWorkouts);
  }, [workoutHistoryList]);

  if (isloading) return <Loader />;

  return (
    <div className="backgroundWhite heading-workout">
      <h6 className="mt-3">{trans("ClientWorkout.workoutHistory")}</h6>
      <div className="client-workout">
        <WorkoutListItemTable
          trans={trans}
          coachId={selectedCoachId}
          group={group}
          length={group.length}
        />
      </div>
    </div>
  );
}

export default WorkoutHistory;
